import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import { bulkCopyTranscriptGradeLevelsMutation } from "../modules/mutations";
import { useErrorHandler } from "TranscriptsV3/hooks";
import _ from "lodash";

export const useBulkCopyGradeLevels = () => {
  const onError = useErrorHandler();
  const [
    mutateFn,
    { loading },
  ] = useMutation(bulkCopyTranscriptGradeLevelsMutation, { onError });

  const bulkCopy = useCallback(
    async ({ sourceStudentId, targetStudentIds }) => {
      const { data } = await mutateFn({
        variables: {
          input: {
            sourceStudentId,
            targetStudentIds,
          },
        },
      });

      return _.get(data, "transcript.bulkCopyTranscriptGradeLevels") || {};
    },
    [mutateFn]
  );

  return { bulkCopy, loading };
};
